import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import SuccessScreen from 'creative-ui/oktaComponents/SuccessScreen';
import { useTranslation } from 'react-i18next';

import errorSvg from '@/assets/error.svg';
import validSvg from '@/assets/valid.svg';
import { BackToLogin } from '@/components/Buttons/BackToLogin';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';

import { useEmailVerificationResultManager } from './hooks/useEmailVerificationResultManager';

function EmailVerificationResultScreen() {
  const { t } = useTranslation('emailVerificationResult');
  useTransactionLocale();

  const { screen } = useEmailVerificationResultManager();

  const status = screen.data?.status;
  const isSuccess = status === 'success' || status === 'already_verified';

  const title = isSuccess ? t('success.title') : t('error.title');
  const description = isSuccess
    ? t('success.description')
    : t('error.description');

  document.title = t('pageTitle');

  return (
    <BaseWrapper>
      <SuccessScreen
        title={title}
        text={description}
        image={isSuccess ? validSvg : errorSvg}
        isTextBeforeImage={false}>
        <BackToLogin />
      </SuccessScreen>
    </BaseWrapper>
  );
}

export default EmailVerificationResultScreen;
